import React from 'react'
import VisionStatementPageOne from './VisionStatementPageOne'
import VisionStatementPageTwo from './VisionStatementPageTwo'
import VisionStatementPageThree from './VisionStatementPageThree'
import VisionStatementPageFour from './VisionStatementPageFour'
import VisionStatementPageFive from './VisionStatementPageFive'
import VisionStatementPageSix from './VisionStatementPageSix'

const VisionStatementExercise = ({ section }) => {
  return (
    <div>
      {section === 0 && <VisionStatementPageOne />}
      {section === 1 && <VisionStatementPageTwo />}
      {section === 2 && <VisionStatementPageThree />}
      {section === 3 && <VisionStatementPageFour />}
      {section === 4 && <VisionStatementPageFive />}
      {section === 5 && <VisionStatementPageSix />}
    </div>
  )
}

export default VisionStatementExercise
